export default "__VITE_ASSET__CA6LJzm1__"